import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";
import * as eventTypes from "./eventTypes";

export const scoringReducer = (state = initialState.document.scoringData, action) => {
  switch (action.type) {
    case actionTypes.LOAD_DOCUMENT_SCORING_RESULT_STARTED: {
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          scoringResult: {
            id: action.id,
            loading: true,
            loaded: false
          }
        }
      };
    }

    case actionTypes.LOAD_DOCUMENT_SCORING_RESULT_SUCCESS: {
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          scoringResult: {
            id: action.id,
            loading: false,
            loaded: true
          }
        }
      };
    }

    case actionTypes.LOAD_DOCUMENT_SCORING_GRIDS_STARTED: {
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          scoringGrids: {
            id: action.id,
            loading: true,
            loaded: false,
            saving: false
          }
        }
      };
    }

    case actionTypes.LOAD_DOCUMENT_SCORING_GRIDS_SUCCESS: {
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          scoringGrids: {
            ...state[action.id].scoringGrids,
            loading: false,
            loaded: true
          }
        }
      };
    }

    case eventTypes.DOCUMENT_SCORING_INVALIDATED: {
      return initialState.document.scoringData;
    }

    default:
      return state;
  }
};
